import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import BadgeIcon from '@mui/icons-material/Badge';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { useNavigate } from 'react-router-dom';
// const pages = ['View My Cases', 'Request New Case'];
// const settings = ['Profile', 'Logout'];
import { ReactComponent as BCHLogoSOP } from '../images/BCH-logo-SOP.svg';
import * as logoutAction from '../actions/logoutAction';
import { useDispatch } from 'react-redux';
import * as caseActions from '../actions/caseActions';
import * as loginActions from '../actions/loginActions';
import { useSelector } from 'react-redux';
import Pageview from '@mui/icons-material/Pageview';
import DriveFolderUploadRounded from '@mui/icons-material/DriveFolderUploadRounded';

export default function AppBarWithMenu() {
  const st = useSelector((state) => state.rootReducer);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleViewCasesNavMenu = () => {
    navigate('/sop2web/home');
    // reset error when navigate out
    if (
      st.updatefirstnameerror !== '' ||
      st.updatelastnameerror !== '' ||
      st.updatephoneerror !== '' ||
      st.updatepwderror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleNewCaseNavMenu = () => {
    dispatch(caseActions.clearCase());
    dispatch(caseActions.setShowWelcome(false));
    navigate('/sop2web/newcase');
    // reset error when navigate out
    if (
      st.updatefirstnameerror !== '' ||
      st.updatelastnameerror !== '' ||
      st.updatephoneerror !== '' ||
      st.updatepwderror !== ''
    )
      dispatch(loginActions.clearError());
  };
  const handleRequestViewNavMenu = () => {
    navigate('/sop2web/requestview');
  };

  const handleProfileNavMenu = () => {
    navigate('/sop2web/profile');
    // reset error when navigate out
    if (
      st.updatefirstnameerror !== '' ||
      st.updatelastnameerror !== '' ||
      st.updatephoneerror !== '' ||
      st.updatepwderror !== ''
    )
      dispatch(loginActions.clearError());
  };

  const handleLogoutNavMenu = () => {
    dispatch(logoutAction.logOut());
    navigate('/sop2web/signin');
  };
  return (
    <AppBar position="static" style={{ background: '#003087', height: 80 }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ mr: 2, display: { xs: 'none', md: 'none', lg: 'flex' } }}>
            <BCHLogoSOP />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit">
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' }
              }}>
              <MenuItem key="View My Cases" onClick={handleViewCasesNavMenu}>
                <BadgeIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                <Typography textAlign="center">View My Cases</Typography>
              </MenuItem>
              <MenuItem key="Request New Case" onClick={handleNewCaseNavMenu}>
                <CreateNewFolderIcon style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                <Typography textAlign="center">Request New Case</Typography>
              </MenuItem>
              <MenuItem key="Request to View" onClick={handleRequestViewNavMenu}>
                <Pageview style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                <Typography textAlign="center">Request to View</Typography>
              </MenuItem>
              {false && (
                <MenuItem key="Upload File">
                  <DriveFolderUploadRounded style={{ fill: '#003087' }} sx={{ fontSize: 50 }} />
                  <Typography textAlign="center">Upload File</Typography>
                </MenuItem>
              )}
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
            <BCHLogoSOP />
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' }, gap: 4, ml: 3 }}>
            <Button
              key="View My Cases"
              onClick={handleViewCasesNavMenu}
              size="iconSizeLarge"
              startIcon={<BadgeIcon />}
              sx={{ my: 2, color: 'white' }}>
              View My Cases
            </Button>
            <Button
              key="Request New Case"
              onClick={handleNewCaseNavMenu}
              size="iconSizeLarge"
              startIcon={<CreateNewFolderIcon />}
              sx={{ my: 0, color: 'white' }}>
              Request New Case
            </Button>
            <Button
              key="Request to View"
              size="iconSizeLarge"
              onClick={handleRequestViewNavMenu}
              startIcon={<Pageview />}
              sx={{ my: 0, color: 'white' }}>
              Request to View
            </Button>
            {false && (
              <Button
                key="Upload File"
                size="iconSizeLarge"
                onClick={handleNewCaseNavMenu}
                startIcon={<DriveFolderUploadRounded />}
                sx={{ my: 0, color: 'white' }}>
                Upload File
              </Button>
            )}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Click to open menu">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <AccountCircle style={{ fill: '#FFFFFF' }} sx={{ fontSize: 50 }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}>
              <MenuItem key="Profile" onClick={handleProfileNavMenu}>
                <Typography textAlign="center">Profile</Typography>
              </MenuItem>
              <MenuItem key="Logout" onClick={handleLogoutNavMenu}>
                <Typography textAlign="center">Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
